<template>
  <v-dialog v-model="visible" persistent :max-width="'50%'">
    <v-card v-if="itemDetail">
      <v-card-title>{{ title }}</v-card-title>
      <v-card-text>
        <div>
          <v-layout v-for="col in getDialogKeys" :key="col.value">
            <v-flex>
              <v-text-field
                v-if="col.value === 'counterId' && itemDetail[col.value]"
                v-model="itemDetail[col.value]"
                :label="col.text"
                :color="Theme.GREEN"
                disabled
              ></v-text-field>
              <v-select
                v-else-if="col.options"
                :color="Theme.GREEN"
                :items="col.options"
                :label="col.text"
                item-text="text"
                item-value="key"
                v-model="itemDetail[col.value]"
              />
              <v-text-field
                v-else-if="col.value !== 'counterId'"
                v-model="itemDetail[col.value]"
                :label="col.text"
                :color="Theme.GREEN"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-btn v-if="showCancel" :color="Theme.PINK" dark @click="cancelEvent"
          >取消</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          dark
          :color="Theme.GREEN"
          :loading="saveLoading"
          @click="confirmEvent"
          >確定</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import common from "@/mixins/common";
import { mapActions } from "vuex";

export default {
  name: "product_detail",
  mixins: [common],
  props: {
    title: String,
    itemDetail: Object,
    visible: Boolean,
    showCancel: Boolean,
  },
  data() {
    return {
      saveLoading: false,
      content: "",
      defaultImageItem: {
        productId: "",
        url: "",
        sort: 0,
        createdDate: new Date(),
        type: 0,
        note: "",
      },
      defaultLinkItem: {
        productId: "",
        title: "",
        url: "",
        createdDate: new Date(),
      },
    };
  },
  created() {},
  mounted() {
    console.log("this is current quill instance object", this.editor);
  },
  computed: {
    editor() {
      if (this.$refs.myQuillEditor) {
        return this.$refs.myQuillEditor.quill;
      }
      return null;
    },
    getDialogKeys() {
      let list = [
        { value: "counterId", text: "ID", sortable: true },
        { value: "name", text: "櫃位", sortable: true },
        { value: "enable", text: "櫃位狀態", options: this.getCounterEnable },
      ];
      return list;
    },
  },
  methods: {
    ...mapActions(["saveCounterInfo"]),
    cancelEvent() {
      this.$emit("cancelEvent");
    },
    async confirmEvent() {
      this.saveLoading = true;

      console.log(`save ${JSON.stringify(this.itemDetail)}`);
      const res = await this.saveCounterInfo({
        token: "",
        info: this.itemDetail,
      });
      const result = res.data;
      if (result.code === 0) {
        this.$emit("confirmEvent", this.itemDetail);
      } else {
        this.showMessageDialog(
          "錯誤",
          result.message ? result.result : "儲存失敗"
        );
      }
      this.saveLoading = false;
    },
    showMessageDialog(title, content) {
      console.log(`showAlert ${title} ${content}`);
      this.showAlert({
        title: title,
        content: content,
        confirmEvent: async () => {
          this.hideAlert();
        },
      });
    },
  },
};
</script>

<style scoped></style>
